/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Github_LinkedInputs */



/**
* | output |
* | --- |
* | "GitHub linked successfully!" |
*
* @param {Profile_Github_LinkedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_github_linked = /** @type {((inputs?: Profile_Github_LinkedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Github_LinkedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("GitHub lié avec succès !")
	if (locale === "es") return /** @type {LocalizedString} */ ("¡GitHub vinculado exitosamente!")
	if (locale === "pt") return /** @type {LocalizedString} */ ("GitHub vinculado com sucesso!")
	if (locale === "it") return /** @type {LocalizedString} */ ("GitHub collegato con successo!")
	return /** @type {LocalizedString} */ ("GitHub linked successfully!")
});